module.exports = __webpack_public_path__ + "static/life-is-what-you-make-it-3eb867a9612b0b37c82b0f9926ebe6ef.jpg";